<div class="r107">
    <div class="container">
        <div class="r107-encabezado">
            <div>
                <p class="r107-titulo text-one-sub">RESULTADOS GLOBALES</p>
                <p class="r107-subtitulo">LIGA INFANTIL Y JUVENIL DE BEISBOL YUCATÁN A.C.</p>
            </div>
            <span class="r107-temporada text-one">TEMPORADA 107</span>
        </div>

        <div class="row" *ngIf="!seccionActiva">
            <div class="col-6 col-lg-3 mb-3" *ngFor="let seccion of secciones">
                <div class="r107-tarjeta" (click)="abrirSeccion(seccion)">
                    <i [class]="seccion.icono"></i>
                    <p class="r107-tarjeta-nombre text-one">{{seccion.nombre}}</p>
                    <p class="r107-tarjeta-desc">{{seccion.descripcion}}</p>
                    <span class="r107-candado" [class.abierto]="estaDesbloqueada(seccion)">
                        <i class="fas" [ngClass]="estaDesbloqueada(seccion) ? 'fa-lock-open' : 'fa-lock'"></i>
                        {{estaDesbloqueada(seccion) ? 'Acceso concedido' : 'Requiere clave'}}
                    </span>
                </div>
            </div>
            <div class="col-12">
                <p class="r107-nota"><i class="fas fa-info-circle"></i> Cada sección requiere una clave de acceso proporcionada por la Liga. Si aún no cuentas con ella, solicítala a los organizadores.</p>
            </div>
        </div>

        <div *ngIf="seccionActiva">
            <div class="r107-visor-encabezado">
                <button class="r107-btn-volver text-one" (click)="volverAlPortal()"><i class="fas fa-arrow-left"></i> VOLVER</button>
                <p class="r107-visor-titulo text-one"><i [class]="seccionActiva.icono"></i> {{seccionActiva.nombre}}</p>
            </div>
            <div class="r107-chips">
                <button *ngFor="let archivo of seccionActiva.archivos" class="r107-chip text-one" [class.activo]="archivo === archivoActivo" (click)="seleccionarArchivo(archivo)">{{archivo.etiqueta}}</button>
            </div>
            <div class="r107-visor" *ngIf="archivoActivo">
                <div class="r107-toolbar">
                    <button (click)="paginaAnterior()" [disabled]="pagina <= 1" title="Página anterior"><i class="fas fa-chevron-left"></i></button>
                    <span class="r107-toolbar-texto">Página {{pagina}} de {{totalPaginas > 0 ? totalPaginas : '—'}}</span>
                    <button (click)="paginaSiguiente()" [disabled]="pagina >= totalPaginas" title="Página siguiente"><i class="fas fa-chevron-right"></i></button>
                    <span class="r107-toolbar-sep"></span>
                    <button (click)="alejar()" title="Alejar"><i class="fas fa-search-minus"></i></button>
                    <span class="r107-toolbar-texto">{{zoomPorcentaje}}%</span>
                    <button (click)="acercar()" title="Acercar"><i class="fas fa-search-plus"></i></button>
                    <span class="r107-toolbar-sep"></span>
                    <a class="r107-descargar" [href]="archivoActivo.ruta" download title="Descargar PDF"><i class="fas fa-download"></i></a>
                    <button (click)="abrirEnPestana()" title="Abrir en otra pestaña"><i class="fas fa-external-link-alt"></i></button>
                </div>
                <div class="r107-lienzo">
                    <div class="r107-aviso" *ngIf="cargandoPdf"><i class="fas fa-spinner fa-spin"></i> Cargando documento...</div>
                    <div class="r107-aviso" *ngIf="errorPdf"><i class="fas fa-exclamation-triangle"></i> No se pudo mostrar el documento, usa el botón de descarga.</div>
                    <pdf-viewer [src]="archivoActivo.ruta" [page]="pagina" [show-all]="false" [original-size]="false" [autoresize]="true" [render-text]="false" [zoom]="zoom" (after-load-complete)="pdfCargado($event)" (error)="pdfError($event)"></pdf-viewer>
                </div>
            </div>
        </div>
    </div>

    <div class="r107-modal-fondo" *ngIf="mostrarModalClave" (click)="cerrarModalClave()">
        <div class="r107-modal" (click)="$event.stopPropagation()">
            <div class="r107-modal-candado"><i class="fas fa-lock"></i></div>
            <p class="r107-modal-titulo text-one">ACCESO RESTRINGIDO</p>
            <p class="r107-modal-sub">Ingresa la clave para ver <strong>{{seccionPendiente?.nombre}}</strong></p>
            <input type="password" class="r107-modal-input" placeholder="Clave de acceso" [(ngModel)]="clave" (keyup.enter)="validarClave()" (input)="claveError = false" autocomplete="off">
            <p class="r107-modal-error" *ngIf="claveError"><i class="fas fa-times-circle"></i> Clave incorrecta, verifica con los organizadores</p>
            <div class="r107-modal-botones">
                <button class="r107-btn-cancelar text-one" (click)="cerrarModalClave()">CANCELAR</button>
                <button class="r107-btn-entrar text-one" (click)="validarClave()" [disabled]="validando || !clave.trim()">{{validando ? 'VALIDANDO...' : 'ENTRAR'}}</button>
            </div>
        </div>
    </div>
</div>
